import React from 'react'
import {Autocomplete, Chip, createFilterOptions, TextField} from "@mui/material";

export const ComboBox = ({
                             label,
                             data,
                             onChange,
                             value,
                             error,
                             onInputChange,
                             isLoading,
                             inputValue,
                             skipSort,
                             isMultiple,
                             disableCloseOnSelect,
                             disabled,
                             freeSolo,
                             testId,
                             placeholder,
                             getOptionKeyImplementation = null,
                             filterOptions = undefined,
                             listboxProps = undefined,
                             renderOption = undefined,
                             style = undefined,
                         }) => {
    return (
        <div className="combobox-div" style={style}>
            <Autocomplete
                filterOptions={createFilterOptions({...filterOptions})}
                multiple={isMultiple === undefined ? true : !!isMultiple}
                disableCloseOnSelect={disableCloseOnSelect === undefined ? true : !!disableCloseOnSelect}
                disabled={disabled ? disabled : false}
                id={label}
                data-testid={testId}
                key={value === null ? label : undefined}
                clearOnBlur={true}
                onInputChange={onInputChange}
                value={value}
                inputValue={inputValue}
                loading={isLoading}
                loadingText={"Searching..."}
                isOptionEqualToValue={
                    (option, selectedValue) => {
                        return option.value === selectedValue.value
                    }
                }
                renderTags={(tagValue, getTagProps) =>
                    tagValue.map((option, index) => {
                        const {key, ...tagProps} = getTagProps({index});

                        return (
                            <Chip
                                key={key}
                                color={option.displayName ? "default" : "error"}
                                label={option.displayName ?? option.value}
                                {...tagProps}
                            />
                        );
                    })
                }
                options={skipSort ? data : data.sort((a, b) => a.displayName.localeCompare(b.displayName))}
                getOptionLabel={(option) => option.description ?? option.displayName}
                getOptionKey={getOptionKeyImplementation}
                renderOption={renderOption}
                onChange={onChange}
                className="combobox-autocomplete"
                renderInput={
                    (params) => (
                        <TextField
                            error={!!error}
                            helperText={error}
                            {...params}
                            variant="outlined"
                            label={label}
                            placeholder={placeholder}
                        />
                    )}
                freeSolo={freeSolo}
                forcePopupIcon={true}
                ListboxProps={listboxProps}
            />
        </div>
    );
}
